/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type StorefrontRefetch_viewer$ref = any;
export type storefrontRootQueryVariables = {
    readonly userId?: string | null;
    readonly userIds?: ReadonlyArray<string | null> | null;
    readonly hasUserId: boolean;
    readonly isTrade: boolean;
    readonly urlLabel: string;
    readonly storefrontId?: number | null;
    readonly sellerId: string;
};
export type storefrontRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": StorefrontRefetch_viewer$ref;
    } | null;
};
export type storefrontRootQuery = {
    readonly response: storefrontRootQueryResponse;
    readonly variables: storefrontRootQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "urlLabel",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "storefrontId",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sellerId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "path",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "caption",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "mediaType",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        } as any),
        (v3 /*: any*/)
    ], v8 = [
        (v1 /*: any*/),
        (v3 /*: any*/)
    ], v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "webPath",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v13 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v14 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v15 = [
        (v14 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "storefrontRootQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StorefrontRefetch_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "storefrontRootQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "sellerId",
                                    "variableName": "sellerId"
                                }
                            ],
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "sellerProfile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SellerProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "company",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "storefrontProfile",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "storefrontId",
                                            "variableName": "storefrontId"
                                        }
                                    ],
                                    "concreteType": "StorefrontProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "aboutUs",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "photos",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Photo",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "type",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PhotoType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "name",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        },
                                        (v3 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "logo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Photo",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v3 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "galleryAlbum",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "MediaAlbum",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "mediaList",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "MediaElement",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "sortOrder",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "element",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "type": "Photo",
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "type": "Video",
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "url",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayCityStateCountry",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "line1",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "line2",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayCountry",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayCityStateZip",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "trackedPhone",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Phone",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "phoneNumber",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isDistinguished",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isRewardsTier2",
                                    "name": "isAnchorListMember",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "listName",
                                            "value": "SELLER_REWARDS_2"
                                        }
                                    ],
                                    "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orderFeedbackPdp",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "metadata",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "aggregatedFeedback",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AggregatedOrderFeedbackType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "overallExperience",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AggregatedOrderFeedbackQuestionType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "mean",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "sellerTiers",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SellerTiers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isGoldTier",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isPlatinumTier",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "sellerPreferences",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SellerPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayStoreAddress",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "storeAddressByAppointmentOnly",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "scrollLogoLg",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasShopTalk",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "shopTalkUrl",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "shopTalkLabel",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasOther",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "otherUrl",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "otherLabel",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "urlLabel",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeAssociations",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeAssociation",
                                    "plural": true,
                                    "selections": (v7 /*: any*/)
                                },
                                (v3 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "favoritesByUser",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "userIds",
                                                    "variableName": "userId"
                                                }
                                            ],
                                            "concreteType": "Favorite",
                                            "plural": true,
                                            "selections": (v8 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "products",
                            "name": "dealerStorefront",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "dealer",
                                    "variableName": "urlLabel"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 12
                                },
                                {
                                    "kind": "Literal",
                                    "name": "storefrontSearch",
                                    "value": "1"
                                }
                            ],
                            "concreteType": "DealerStorefrontQueryConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "DealerStorefrontQueryEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "categoryPath",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "categoryCode",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ecommerceTrackingParams",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isCustomizable",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isMultiSku",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "localizedPdpUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "vertical",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "displayPrice",
                                                    "storageKey": null,
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isTrade",
                                                            "variableName": "isTrade"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "page",
                                                            "value": "searchAndBrowse"
                                                        }
                                                    ],
                                                    "concreteType": "ItemDisplayPriceType",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "convertedAmountList",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ConvertedAmountList",
                                                            "plural": true,
                                                            "selections": [
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "quantityDisplay",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "percentageOff",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "type",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "showPriceLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "showPriceVariability",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "lowestShipmentQuote",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentQuote",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "complimentaryShipping",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "totalAmount",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "FinancialAmount",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "convertedAmountList",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ConvertedAmountList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        (v10 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "serviceMethod",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShipmentServiceMethod",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "isWhiteGlove",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v3 /*: any*/)
                                                            ]
                                                        },
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "classification",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ItemClassification",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "creationDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "creators",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ItemCreator",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "attribution",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "creator",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Creator",
                                                            "plural": false,
                                                            "selections": (v7 /*: any*/)
                                                        },
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": "productPhotos",
                                                    "name": "photos",
                                                    "storageKey": "photos(limit:1)",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "limit",
                                                            "value": 1
                                                        }
                                                    ],
                                                    "concreteType": "ItemPhoto",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "placeholder",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "smallPath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "masterOrZoomPath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v12 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "quickViewDisplay",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "QuickViewDisplayType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": "mobileTitle",
                                                            "name": "title",
                                                            "args": (v13 /*: any*/),
                                                            "storageKey": "title(formatType:\"MOBILE\")"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "paragraphs",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "QuickViewParagraph",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "key",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "text",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": "mobileText",
                                                                    "name": "text",
                                                                    "args": (v13 /*: any*/),
                                                                    "storageKey": "text(formatType:\"MOBILE\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "photos",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ItemPhoto",
                                                    "plural": true,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "condition": "hasUserId",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": "folderPortfolioItems",
                                                            "name": "portfolioItems",
                                                            "storageKey": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "portfolioType",
                                                                    "value": "FOLDER"
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "concreteType": "PortfolioItemV2",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v3 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": "heartPortfolioItems",
                                                            "name": "portfolioItems",
                                                            "storageKey": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "portfolioType",
                                                                    "value": "HEART"
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "concreteType": "PortfolioItemV2",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "portfolioId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "portfolioItemId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v3 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v3 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v15 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": (v8 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "viewerUser",
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v15 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "displayName",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "preventEmailFallback",
                                                            "value": true
                                                        }
                                                    ],
                                                    "storageKey": "displayName(preventEmailFallback:true)"
                                                }
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "primaryPhone",
                                    "storageKey": null,
                                    "args": (v15 /*: any*/),
                                    "concreteType": "Phone",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "countryCodeNumber",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "formattedPhoneNumber",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": "isActive",
                                            "name": "hasStatus",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "status",
                                                    "value": "ACTIVE"
                                                }
                                            ],
                                            "storageKey": "hasStatus(status:\"ACTIVE\")"
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "HEART"
                                            ]
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "userIds",
                                            "variableName": "userIds"
                                        }
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v8 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "storefrontRootQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/storefrontRootQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8586bdc1b72c853a8a11484a1c2ead0e';
export default node;
